import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";

function write_point(param) {
  return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.$$float, Atdgen_codec_runtime.Encode.$$float, param);
}

function read_point(param) {
  return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.$$float, Atdgen_codec_runtime.Decode.$$float, param);
}

function write__1(param) {
  return Atdgen_codec_runtime.Encode.list(write_point, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.list(read_point, param);
}

var write_t = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "cpu", t.cpu),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "mem", t.mem),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr0("Not_implemented");
  }), "disk", t.disk),
  /* [] */
  0]]]);
});
var read_t = Atdgen_codec_runtime.Decode.make(function (json) {
  var partial_arg = Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Not_implemented",
  /* `Single */
  [-306849112,
  /* Not_implemented */
  -498198474]],
  /* [] */
  0]);
  return {
    cpu: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("cpu", read__1, param);
    }, json),
    mem: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("mem", read__1, param);
    }, json),
    disk: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("disk", partial_arg, param);
    }, json)
  };
});
export { read_point, write_point, read_t, write_t };
/* write_t Not a pure module */